import { hourlyMovingVolumeByMan, minLabour } from '../quotes.const'

export const estimateMovingLabourTime = (volume: number, nbMen: number) => {
  const nbHours = volume / (nbMen * hourlyMovingVolumeByMan)
  return Math.max(Math.ceil((nbHours * 10)) / 10, minLabour)
}
